// Declines a test PayMongo Wallet debit can be failed with. test-sources-api sends each as the
// Transfers rejection core-api maps onto that code; transaction_failed is the generic failure.
export const PAYMONGO_WALLET_DECLINE_CODE = {
  insufficientFunds: 'insufficient_funds',
  walletInactive: 'wallet_inactive',
  walletLimitExceeded: 'wallet_limit_exceeded',
  transactionFailed: 'transaction_failed'
};

export const PAYMONGO_WALLET_DECLINE_CODES = [
  { code: PAYMONGO_WALLET_DECLINE_CODE.insufficientFunds, label: 'Insufficient funds' },
  { code: PAYMONGO_WALLET_DECLINE_CODE.walletInactive, label: 'Wallet inactive' },
  { code: PAYMONGO_WALLET_DECLINE_CODE.walletLimitExceeded, label: 'Wallet limit exceeded' },
  { code: PAYMONGO_WALLET_DECLINE_CODE.transactionFailed, label: 'Generic failure' }
];
